import { render } from "./driver.longhorn.io_v1.vue?vue&type=template&id=67761b17&scoped=true"
import script from "./driver.longhorn.io_v1.vue?vue&type=script&lang=js"
export * from "./driver.longhorn.io_v1.vue?vue&type=script&lang=js"

import "./driver.longhorn.io_v1.vue?vue&type=style&index=0&id=67761b17&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67761b17"]])

export default __exports__